export const SNAKE_CASE_REGEX = /(_\w)/g;

export const CAPITAL_LETTERS_REGEX = /[A-Z]/g;

export const BLANK_REGEX = /^\s*$/;

export const NUMBERS_REGEX = /\d+/g;

export const LETTERS_REGEX = /\D+/g;

export const SPACES_REGEX = /\s/g;
